import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pageItem", "labelTitle", "labelDescription"]
  static values = {
    qrTitle: { type: String, default: "QR Codes" },
    qrDescription: { type: String, default: "Easy check-ins and instant ticket access" },
    emailTitle: { type: String, default: "Email Campaigns" },
    emailDescription: { type: String, default: "Reach customers with personalized ticket offers" },
    widgetTitle: { type: String, default: "Embedded Widgets" },
    widgetDescription: { type: String, default: "Sell tickets directly on your website" }
  }

  connect() {
    this.currentPage = 0
    this.startAnimation()
  }

  disconnect() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval)
    }
  }

  startAnimation() {
    this.animationInterval = setInterval(() => this.switchPage(), 3000)
  }

  switchPage() {
    if (this.pageItemTargets.length === 0) return

    // Fade out current page
    this.pageItemTargets[this.currentPage].classList.remove('active')

    // Move to next page
    this.currentPage = (this.currentPage + 1) % this.pageItemTargets.length

    // Update labels
    const nextPageType = this.pageItemTargets[this.currentPage].getAttribute('data-page')
    this.updateLabels(nextPageType)

    // Fade in new page
    setTimeout(() => {
      this.pageItemTargets[this.currentPage].classList.add('active')
    }, 200)
  }

  updateLabels(pageType) {
    const pageData = {
      'qr': {
        title: this.qrTitleValue,
        description: this.qrDescriptionValue
      },
      'email': {
        title: this.emailTitleValue,
        description: this.emailDescriptionValue
      },
      'widget': {
        title: this.widgetTitleValue,
        description: this.widgetDescriptionValue
      }
    }

    if (pageData[pageType]) {
      this.labelTitleTarget.textContent = pageData[pageType].title
      this.labelDescriptionTarget.textContent = pageData[pageType].description
    }
  }
}
